// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ff37a7e","389":"2d1eb9ec","453":"6bd4553c","455":"ffd7ecd7","457":"1ef3e3ed","551":"73d7292d","851":"ddbd0a22","977":"002546ef"}[chunkId] + ".chunk.js";
};